import CustomType from './Custom';

export default class Any extends CustomType {
  parse() {
    return true;
  }
}
